import { useState, useEffect } from 'react';
import Anumita from '../../assets/images/Anumita.jpeg';
import Bpraak from '../../assets/images/Bpraak.jpeg';
import Judy from '../../assets/images/Judy.jpg';
import QARAN from '../../assets/images/QARAN.jpg';
import vishal from '../../assets/images/vishal.jpeg';
import VILEN from '../../assets/images/VILEN.jpeg';
import bigbadwolfLogo from '../../assets/images/big bad wolf.png';
import forevisionLogo from '../../assets/images/forevision.png';
import darkmusiccompanyLogo from '../../assets/images/dark music company.png';
import madverseLogo from '../../assets/images/madverse.png';
import saregamaLogo from '../../assets/images/saregama.png';
import SongDewLogo from '../../assets/images/Song Dew.png';
import universalLogo from '../../assets/images/universal.png';
import panaromeLogo from '../../assets/images/panarome.png';
import artist1 from '../../assets/images/artists-image1.jpeg';
import artist2 from '../../assets/images/artists-image2.jpeg';
import artist3 from '../../assets/images/artists-image3.jpeg';
import artist4 from '../../assets/images/artists-image4.jpeg';
import artist5 from '../../assets/images/artists-image5.jpeg';
import artist6 from '../../assets/images/artists-image6.jpeg';

const ArtistBrandCarousel = () => {
  const [currentIndex, setCurrentIndex] = useState(0);
  const artists = [
    { id: 1, image: artist1, bg: 'bg-purple-300' },
    { id: 2, image: artist2, bg: 'bg-cyan-300' },
    { id: 4, image: artist3, bg: 'bg-amber-200' },
    { id: 5, image: artist4, bg: 'bg-pink-300' },
    { id: 6, image: artist5, bg: 'bg-pink-300' },
    { id: 7, image: artist6, bg: 'bg-pink-300' },
    { id: 8, image: Anumita, bg: 'bg-purple-300' },
    { id: 9, image: Bpraak, bg: 'bg-cyan-300' },
    { id: 10, image: Judy, bg: 'bg-amber-200' },
    { id: 11, image: QARAN, bg: 'bg-pink-300' },
    { id: 12, image: vishal, bg: 'bg-pink-300' },
    { id: 13, image: VILEN, bg: 'bg-pink-300' },
  ];
  const brands = [madverseLogo, panaromeLogo, saregamaLogo, SongDewLogo, universalLogo, bigbadwolfLogo, darkmusiccompanyLogo, forevisionLogo];
  useEffect(() => {
    const interval = setInterval(() => {
      setCurrentIndex((prev) => (prev + 1) % (artists.length - 1));
    }, 3000);
    return () => clearInterval(interval);
  }, []);
  return (
    <div className="min-h-screen bg-black text-white">
      <div className="py-16">
        <h1 className="text-2xl lg:text-5xl font-normal text-center mb-10 font-inter">ARTISTS</h1>
        <div className="overflow-hidden w-full py-8">
          <div className="flex w-max animate-marquee">
            {[...artists, ...artists].map((artist, index) => (
              <div
                key={index}
                className=" mx-4 flex-shrink-0 w-[330px] h-[330px]"
              >
                <div className={`${artist.bg} rounded-3xl p-4 aspect-square flex items-end relative overflow-hidden group`}>
                  <img
                    src={artist.image}
                    alt={index}
                    className="absolute inset-0  object-cover rounded-3xl transition-transform duration-300 group-hover:scale-105 w-full h-full"
                  />
                  <div className="absolute inset-0 bg-gradient-to-t from-black/60 to-transparent rounded-3xl" />
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <div className="py-16">
        <h1 className="text-2xl lg:text-5xl font-normal text-center mb-10 font-inter">BRANDS</h1>
        <div className="overflow-hidden">
          <div className="flex animate-scroll w-max">
            {[...brands, ...brands].map((brand, index) => (
              <div key={index} className="flex items-center space-x-8 px-10 whitespace-nowrap">
                <div className="flex items-center space-x-3 w-[94px] h-[88px]">
                  <img src={brand} className='w-[94px] h-[88px]' />
                  {/* {brand === 'Relume' ? (
                    <>
                      <div className="w-8 h-8 bg-purple-600 rounded-lg flex items-center justify-center">
                        <div className="w-4 h-4 border-2 border-white rounded"></div>
                      </div>
                      <span className="text-2xl font-semibold text-purple-400">Relume</span>
                    </>
                  ) : (
                    <>
                      <div className="text-purple-400 text-2xl font-bold">W</div>
                      <span className="text-2xl font-semibold text-purple-400">Webflow</span>
                    </>
                  )} */}
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
      <style jsx="true">{`
        @keyframes scroll {
          0% { transform: translateX(0); }
          100% { transform: translateX(-50%); }
        }
        .animate-scroll {
          animation: scroll 20s linear infinite reverse;
        }
      `}</style>
      <div className="flex flex-col justify-center items-center text-center md:px-8 lg:px-12  w-full h-[45vh] md:h-auto overflow-hidden ">
        {/* Mobile Image */}
        <img
          src={'https://res.cloudinary.com/dhjzae1cm/image/upload/v1757969738/ezgif-22fa755950e0b8_ft9nyz.gif'}
          alt="Artist"
          className="w-full h-auto md:hidden"
          style={{ maxWidth: '100%', height: 'auto' }}
        />

        {/* Desktop Video */}
        <video
          controls={false}
          className="w-full h-full object-cover md:h-auto pointer-events-none no-overlay hidden md:block"
          src={'https://res.cloudinary.com/dhjzae1cm/video/upload/v1757246241/artist_screen_video_ea2f6n.mp4'}
          autoPlay
          loop
          preload="metadata"
          muted
          playsInline
          // controls={false} // ensures no controls are shown
          disablePictureInPicture // disables PiP mode in iOS Safari
          // controlsList="nodownload nofullscreen noremoteplayback" // extra control suppression
        // style={{ maxWidth: '100%', height: 'auto' }}
        />
      </div>
    </div>
  );
};
export default ArtistBrandCarousel;